// @ts-ignore
import i18n from "i18next";
// @ts-ignore
import languageDetector from "i18next-browser-languagedetector";
import {reactI18nextModule} from "react-i18next";

const resources = {
    de: require('./de.json'),
    en: require('./en.json'),
    nl: require('./nl.json')
};

i18n
    .use(languageDetector)
    .use(reactI18nextModule)
    .init({
        resources,
        interpolation: {
            escapeValue: false
        },
        debug: process.env.NODE_ENV !== 'production',
        keySeparator: ".",
        fallbackLng: "de"

    });


export default i18n;